import FooterLoginIssues from './FooterLoginIssues';

export default FooterLoginIssues;
